import script from "./CountryAndLanguageSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./CountryAndLanguageSelector.vue?vue&type=script&lang=ts&setup=true"

import "./CountryAndLanguageSelector.vue?vue&type=style&index=0&id=39c6739f&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c6739f"]])

export default __exports__